export const menu = [
    {
        arm: "Գլխավոր",
        ru: "Главная",
        eng: "Home",
        fr: "Accueil",
        link: "#home",
    },
    {
        arm: "Մեր պրոդուկտները",
        ru: "Наши продукты",
        eng: "Our products",
        fr: "Nos produits",
        link: "#products",
    },
    {
        arm: "Հետադարձ կապ",    
        ru: "Связаться с нами",
        eng: "Contact us",
        fr: "Contactez-nous",
        link: "#contact",
    }
]